import { Sphere, Vector3 } from 'three';
import type { BoxerRig } from './boxer/boxer';

/** A glove's padded fist, as a ball, for keeping it out of heads and bodies. */
export const gloveRadius = 0.12;
/** The middle of the opponent's padded fist, in his glove joint's space: the knuckles point along +Z. */
export const boxerFistInGlove = new Vector3(0, 0.0134, 0.19);
/** The middle of the player's padded fist, in his glove's space: the knuckles point along -Z. */
export const playerFistInGlove = new Vector3(0, 0.012, -0.17);

// His parts, each a ball placed from one of his joints: (joint, offset in its space, radius).
const boxerBalls = [
  ['head', new Vector3(0, 0.13, 0.02), 0.175],
  ['head', new Vector3(0, 0.02, 0.07), 0.12],
  ['chest', new Vector3(0, 0.3, 0.03), 0.3],
  ['hips', new Vector3(0, 0.17, 0.06), 0.22],
] as const;

/** An empty body of so many balls, to be placed each frame. */
export function balls(count: number): Sphere[] {
  return Array.from({ length: count }, () => new Sphere(new Vector3(), 0));
}

export const boxerBallCount = boxerBalls.length;

/** His fists as balls in the world, where his gloves are now: the player's punches stop on them. */
export function placeBoxerFists(rig: BoxerRig, out: readonly Sphere[]): void {
  [rig.left.glove, rig.right.glove].forEach((glove, i) => {
    glove.localToWorld(out[i].center.copy(boxerFistInGlove));
    out[i].radius = gloveRadius;
  });
}

/** His head, jaw, chest and belly as balls in the world, where his joints are now. */
export function placeBoxerBalls(rig: BoxerRig, out: readonly Sphere[]): void {
  boxerBalls.forEach(([joint, offset, radius], i) => {
    rig[joint].localToWorld(out[i].center.copy(offset));
    out[i].radius = radius;
  });
}
